import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AppServiceService } from 'src/app/api/app-service.service';
import { StorageService } from '../../core/storage.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-past-order',
  templateUrl: './past-order.page.html',
  styleUrls: ['./past-order.page.scss'],
})
export class PastOrderPage implements OnInit {
  @Output() onOrderSelect: EventEmitter<any> = new EventEmitter();

  public customerDetails = {
    customer_id: '',
  };
  public pastOderList: any;
  public langMsg: any;

  constructor(public appService: AppServiceService, public storage: StorageService,
    public translate: TranslateService, private router: Router) { }

  ngOnInit() {

  }

  // ionViewWillEnter(){
  //   this.appService.appObject.isLoading = true;
  //   this.getLang();
  //   setTimeout(() => {
  //     this.getCustomer();
  //   }, 500);

  // }

  ngAfterViewInit() {
    setTimeout(() => {
      this.appService.appObject.isLoading = true;
    }, 10);
    this.getLang();
    setTimeout(() => {
      this.getCustomer();
    }, 500);
  }

  async getLang() {
    this.translate.get('key').subscribe(
      value => {
        this.langMsg = value;
      }
    )
  }

  getCustomer() {

    this.customerDetails.customer_id = this.appService.appObject.userId;
    this.getOrderDetails();
  }

  getOrderDetails() {
    // this.appService.showAlert('success','Customer ID' , this.appService.appObject.userId, false);
    this.appService.customerOrderList(this.customerDetails).then(response => {
      if (response.status) {
        this.pastOderList = response.data;
      }
      this.appService.appObject.isLoading = false;
    }, error => {
      this.appService.appObject.isLoading = false;
    });
  }

  setDateTime(datetime) {
    var month = new Date(datetime).getMonth();
    month++;
    var day = new Date(datetime).getDate();
    var year = new Date(datetime).getFullYear();
    var hours: any = new Date(datetime).getHours();
    var minutes: any = new Date(datetime).getMinutes();
    if (hours < 10) {
      hours = '0' + hours;
    }
    if (minutes < 10) {
      minutes = '0' + minutes
    }
    return year + '/' + month + '/' + day + ' ' + hours + ':' + minutes;
  }

  orderDeliveryType(order_delivery_type) {
    if (order_delivery_type === 'pickup') {
      return this.langMsg.pickup;
    }
    else if (order_delivery_type === 'delivery') {
      return this.langMsg.delivery;
    }
    else if (order_delivery_type === 'dine_in') {
      return this.langMsg.dine_in;
    }
  }

  orderStatus(status) {
    if (status === 'processing') {
      return this.langMsg.processing;
    } else if (status === 'accepted') {
      return this.langMsg.accepted;
    } else if (status === 'cancelled') {
      return this.langMsg.cancelled;
    } else if (status === 'paid') {
      return this.langMsg.paid;
    } else if (status === 'rejected') {
      return this.langMsg.rejected;
    } else if (status === 'completed') {
      return this.langMsg.completed;
    }
  }

  /**
   * 
   * @param order 
   */
  navigateToOrderDetail(order) {
    if (this.appService.isWebVersion) this.onOrderSelect.emit([order.payment_id, order.order_delivery_type]);
    else this.router.navigate(['order-summery', order.payment_id]);
  }

}
